import moment from "moment";
import { toThousands } from "@/utils/common.js";

export function separatorFormatter(value, isInit, initValue) {
  const _initValue = typeof initValue !== "undefined" ? initValue : "-";
  if (isInit && !value) { return _initValue; }

  if (!value && value !== 0) {
    return "";
  }

  const _value = toThousands(value);
  return _value;
}

export function currencyFormatter(value, isInit, initValue) {
  const _initValue = typeof initValue !== "undefined" ? initValue : "-";
  if (isInit && !value) { return _initValue; }

  if (!value && value !== 0) {
    return "";
  }

  const _value = toThousands(value);
  return `¥ ${_value}`;
}

export function dateFormatter(value, _format = "YYYY-MM-DD") {
  if (!moment(value).isValid()) {
    return "-";
  }

  return moment(value).format(_format);
}